import { Box, Typography } from "@bca/ui-library";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { useViewport } from "../Hooks/useViewport.hook";
import CTAs from "./CTAs";
import NoTransport from "./variants/NoTransport";

import type { Vehicle } from "../Interfaces/vehicle.type";
import type { TransportModalData } from "../VehicleCard/VehicleCardMobile";

import bookDeliveryDataPush from "../AdobeDataPushes/transportModal/bookDeliveryDataPush";
import bookCollectionDataPush from "../AdobeDataPushes/transportModal/bookCollectionDataPush";
import callCustomerServiceDataPush from "../AdobeDataPushes/transportModal/callCustomerServiceDataPush";
import emailCustomerServiceDataPush from "../AdobeDataPushes/transportModal/emailCustomerServiceDataPush";
import DeliveryCards from "./variants/DeliveryCards";
import Collections from "./Options/Collections";
import { storeType } from "../redux/store";
import bookExportDeliveryDataPush from "../AdobeDataPushes/transportModal/bookExportDeliveryDataPush";

import getSectionType from "../VehicleCard/getSectionType";
import TransportModalSundryMessages from "../VehicleCard/TransportModalSundryMessages";
import { getFeatureFlagService } from "../../apiService";

const getTransportModalVariant = (
  isDeliveryModal,
  isCentralOffsiteLocation
) => {
  if (isDeliveryModal || isCentralOffsiteLocation === false) {
    return "delivery";
  } else {
    return "noTransport";
  }
};

interface ITransportModalContent {
  onClose: () => void;
  openInvoiceModal: () => void;
  vehicle: Vehicle;
  degradedServices: string[];
  transportModalData: TransportModalData;
}

const TransportModalContent = ({
  vehicle,
  degradedServices,
  onClose,
  transportModalData,
  openInvoiceModal,
}: ITransportModalContent) => {
  const store = useSelector((state: storeType) => ({
    exportFlag: state.app.exportFlag,
  }));
  const variant = getTransportModalVariant(
    transportModalData.isDeliveryModal,
    vehicle.isCentralOffsiteLocation
  );
  const [isLateStorageFees, setLateStorageFees] = React.useState(false);

    useEffect(() => {
    getFeatureFlagService("EnableLatePaymentFees")
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
      })
      .then((response) => {
        if (response?.enabled) {
          setLateStorageFees(response.enabled);
        }
      });
  }, []);

  const bookDeliveryOnClickHandler = () => {
    bookDeliveryDataPush(vehicle);
  };

  const bookCollectionsOnClickHandler = () => {
    bookCollectionDataPush(vehicle);
  };

  const bookExportDeliveryOnClickHandler = () => {
    bookExportDeliveryDataPush(vehicle);
  };
  const callCustomerServiceOnClickHandler = () => {
    callCustomerServiceDataPush(vehicle);
  };
  const emailCustomerServiceOnClickHandler = () => {
    emailCustomerServiceDataPush(vehicle);
  };

  const viewportWidth = useViewport();

  const TransportModalSettings = {
    noTransport: {
      title: "Transport Options",
      content: <NoTransport />,
    },
    delivery: {
      title: "Transport Options",
      content: (
        <>
          <DeliveryCards
            transportModalData={transportModalData}
            bookDeliveryOnClickHandler={bookDeliveryOnClickHandler}
            bookExportDeliveryOnClickHandler={bookExportDeliveryOnClickHandler}
            callCustomerServiceOnClickHandler={
              callCustomerServiceOnClickHandler
            }
            emailCustomerServiceOnClickHandler={
              emailCustomerServiceOnClickHandler
            }
            exportFlag={store.exportFlag}
            sundryMessages={TransportModalSundryMessages({
              vehicle,
              sectionType: getSectionType(vehicle, degradedServices),
            })}
            isLateStorageFees={isLateStorageFees}
          />

          <Collections
            closeTransportModal={onClose}
            bookCollectionsOnClickHandler={bookCollectionsOnClickHandler}
            location={transportModalData.collectionsLocation}
            sundryMessages={TransportModalSundryMessages({
              vehicle,
              sectionType: getSectionType(vehicle, degradedServices),
              openInvoiceModal,
            })}
            isLateStorageFees={isLateStorageFees}
          />
        </>
      ),
    },
  };

  return (
    <Box
      margin="0"
      display="flex"
      flexDirection="column"
      height="100%"
      overflowY="scroll"
      paddingX={{
        mobile: "20px",
        desktop: "64px",
      }}
    >
      <Box
        marginTop={{
          mobile: "71px",
          desktop: "52px",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          marginTop={0}
          marginBottom={4}
        >
          {TransportModalSettings[variant].title}
        </Typography>
      </Box>
      {TransportModalSettings[variant].content}
      <CTAs viewportWidth={viewportWidth} onClose={onClose}></CTAs>
    </Box>
  );
};

export default TransportModalContent;
